import { SVGProps } from "react";

export function ArrowUp(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.6594 21.8792C11.6681 21.8307 11.6862 21.7844 11.7127 21.7428C11.7392 21.7013 11.7737 21.6654 11.8141 21.6372C11.8546 21.609 11.9001 21.5891 11.9483 21.5785C11.9964 21.568 12.0461 21.567 12.0947 21.5757L20.601 23.0919L11.6802 10.3011C11.6233 10.2195 11.6012 10.1187 11.6186 10.0208C11.6361 9.92287 11.6917 9.8359 11.7733 9.77901C11.8549 9.72211 11.9557 9.69996 12.0536 9.71741C12.1515 9.73486 12.2385 9.7905 12.2954 9.87207L21.2162 22.6629L22.7324 14.1565C22.741 14.108 22.7592 14.0617 22.7857 14.0202C22.8123 13.9787 22.8467 13.9428 22.8871 13.9146C22.9276 13.8864 22.9731 13.8665 23.0212 13.8559C23.0694 13.8453 23.1191 13.8444 23.1676 13.853C23.2161 13.8616 23.2625 13.8798 23.304 13.9063C23.3455 13.9329 23.3813 13.9673 23.4095 14.0077C23.4377 14.0482 23.4577 14.0937 23.4682 14.1419C23.4788 14.19 23.4798 14.2397 23.4712 14.2882L21.796 23.686C21.7874 23.7346 21.7693 23.7809 21.7428 23.8224C21.7162 23.864 21.6817 23.8998 21.6413 23.928C21.6009 23.9562 21.5553 23.9762 21.5072 23.9867C21.459 23.9973 21.4093 23.9983 21.3608 23.9896L11.963 22.3144C11.9145 22.3058 11.8681 22.2877 11.8266 22.2612C11.7851 22.2346 11.7492 22.2002 11.721 22.1597C11.6928 22.1193 11.6729 22.0737 11.6623 22.0256C11.6517 21.9775 11.6508 21.9277 11.6594 21.8792Z"
        fill="currentColor"
      />
    </svg>
  );
}
